const DOCUMENT_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const MAX_CUSTOM_PAGE_DOCUMENT_IDS = 50;

export const normalizeDocumentIds = (value) => {
  if (!Array.isArray(value)) return [];
  const seen = new Set();
  const out = [];
  for (const raw of value) {
    const id = String(raw || "").trim().toLowerCase();
    if (!DOCUMENT_ID_RE.test(id) || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
};

export const pruneDocumentIds = (documentIds, companyDocuments, { ready } = {}) => {
  const ids = normalizeDocumentIds(documentIds);
  if (!ready) return ids;
  const allowed = new Set((companyDocuments || []).map((doc) => String(doc.id).toLowerCase()));
  return ids.filter((id) => allowed.has(id));
};

export const filterPickerDocuments = (documents, { search = "", selectedIds = [] } = {}) => {
  const selected = new Set(normalizeDocumentIds(selectedIds));
  const q = String(search || "").trim().toLowerCase();
  return (Array.isArray(documents) ? documents : []).filter((doc) => {
    if (!doc?.id || selected.has(String(doc.id).toLowerCase())) return false;
    if (!q) return true;
    return (
      String(doc.name || "").toLowerCase().includes(q) ||
      String(doc.fileName || "").toLowerCase().includes(q)
    );
  });
};

export const intersectDocumentsByIds = (documents, documentIds) => {
  const wanted = new Set(normalizeDocumentIds(documentIds));
  return (Array.isArray(documents) ? documents : []).filter((doc) =>
    wanted.has(String(doc?.id || "").toLowerCase())
  );
};

const IMAGE_EXT = new Set(["png", "jpg", "jpeg", "webp", "svg"]);

export const isImageDocument = (doc) => {
  const mime = String(doc?.mimeType || "").toLowerCase();
  if (mime.startsWith("image/")) return true;
  const fileName = String(doc?.fileName || "");
  const ext = (fileName.split(".").pop() || "").toLowerCase();
  return IMAGE_EXT.has(ext);
};

export const sortDocumentsByName = (documents) =>
  [...(Array.isArray(documents) ? documents : [])].sort((a, b) =>
    String(a.name || a.fileName || "").localeCompare(String(b.name || b.fileName || ""), undefined, {
      sensitivity: "base",
      numeric: true,
    })
  );
